import { DatePipe } from '@angular/common';
import { Component, OnInit, QueryList, TemplateRef, ViewChild, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { IsPermissionExist } from 'src/app/helpers/get-permissions';
import { showNotification } from 'src/app/helpers/show-toast';
import { PspEvaPermission, PspLillyPermission } from 'src/app/_constants/permissions.constant';
import { ColumnSortingDirective } from 'src/app/_directives/column-sorting.directive';
import { IColumnSortEvent } from 'src/app/_interfaces/i-column-sort-event';
import { MedicalRequest } from 'src/app/_models/PSP/medical-requests.model';
import * as XLSX from 'xlsx';
import { TableColumn } from '@swimlane/ngx-datatable';
import { ISmartTableMessage } from 'src/app/_interfaces/smart-table/i-message';
import { ISmartTablePagination } from 'src/app/_interfaces/smart-table/i-pagination';
import { PSPPatientService } from 'src/app/_services/PSP/patient.service';
import { FinglodineSubscriptionsItems, FinglodineSubscriptionsResponseData} from 'src/app/_models/PSP/finglodine-subscriptions';

@Component({
  selector: 'app-finglodine-subscriptions',
  templateUrl: './finglodine-subscriptions.component.html',
  styleUrls: ['./finglodine-subscriptions.component.css']
})
export class FinglodineSubscriptionsComponent implements OnInit {
  pageTitle: string = 'Finglodine Subscriptions';
  apiParams: any = {
    searchKey:"",
    pageSize: 10,
    page: 1,
    sort: true,
  };
  totalItems: number;
  currentPage: number;
  pageSize: number;
  medicationRequestsCounter: any;
  requestArray: FinglodineSubscriptionsItems[] = [];
  exportedRequestArray: FinglodineSubscriptionsItems[] = [];
  invertSort = true;
  eligiblePrograms: string[] = [];
  modalRef: BsModalRef;
  columns: TableColumn[];
  messages: ISmartTableMessage = {
    emptyMessage: 'Oh !! There is No Subscrptions',
    totalMessage: 'total',
    selectedMessage: ''
  }
  searchValue: string = "";
  pageSelectionId: number = 1;

  constructor(
    private pspPatientService: PSPPatientService,
    private router: Router,
    private datePipe: DatePipe,
    private toastr: ToastrService,
    private bsModalService: BsModalService,
  ) {}

  ngOnInit(): void {
    this.onSearch("");
  }

  onSearch(apiParams): void {

    this.apiParams.pageSize = 10;
    this.apiParams.sort = this.invertSort;

    this.pspPatientService.getFinglodineSubscriptionData(this.apiParams).subscribe((res) => {
      this.requestArray = res.data.items;
      this.apiParams.page = res?.data?.pagination.currentPage;
      
      this.totalItems = res?.data?.pagination.totalItems;

      this.columns = [
        {prop: 'name', name: 'Patient Name'},
        {prop: 'pspCode', name: 'PSP Code'},
        {prop: 'mobileNumber', name: 'Mobile No.'},
        {prop: 'enrollmentStatus', name: 'Enrollment Status'},
        {prop: 'subscriptionDate', name: 'Subscription Date (Activation Date)'},
        {prop: 'statusOfLabTest', name: 'Status Of Lab Test'},
        {prop: 'labTestRequestDate', name: 'Lab Test Approval Date'},
        {prop: 'labTestResultDate', name: 'Lab Test Results Date'},
        {prop: 'statusOfRadiologyTest', name: 'Status Of Radiology Test'},
        {prop: 'radiologyRequestDate', name: 'Radiology Test Approval Date'},
        {prop: 'radiologyResultDate', name: 'Radiology Test Results Date'},
        {prop: 'statusOfFDO', name: ' Status of FDO'},
        {prop: 'fdoRequestDate', name: 'FDO Approval Date'},
        {prop: 'fdoResultDate', name: 'FDO Report Date'}
      ]
    });
  }

  onSearchPatients(searchVal: string) {

    this.apiParams.searchKey = searchVal;
    this.pageSelectionId = 1;
    if(searchVal){
      this.pspPatientService
        .getFinglodineSubscriptionData(this.apiParams)
        .subscribe((res) => {
          this.requestArray = res.data.items;
          this.apiParams.page = res?.data?.pagination.currentPage;
          this.totalItems = res.data.items.length;
          this.apiParams.pageSize = res.data.items.length;
        });
    
        
    }
    else {
      this.onSearch(this.searchValue);
    }
  }

  ExportTOExcel() {
    this.exportedRequestArray = [];
    this.apiParams.pageSize = this.totalItems;
    this.apiParams.page = 1;
    this.currentPage = 1;
    this.pageSize = this.apiParams.pageSize;

    this.pspPatientService.getFinglodineSubscriptionData(this.apiParams).subscribe((res) => {
      res.data.items.map((item) => {
        this.exportedRequestArray.push(item);
      });

      const data = [];
      this.exportedRequestArray.map((request, index) =>
        data.push({
          FullName: request.name,
          PSPCode: request.pspCode,
          MobileNumber: request.mobileNumber,
          EnrollmentStatus: request.enrollmentStatus,
          SubscriptionDate: request.subscriptionDate,
          StatusOfLabTest: request.statusOfLabTest,
          LabTestRequestDate: request.labTestRequestDate,
          LabTestResultDate: request.labTestResultDate,
          StatusOfRadiologyTest: request.statusOfRadiologyTest,
          RadiologyRequestDate: request.radiologyRequestDate,
          RadiologyResultDate: request.radiologyResultDate,
          StatusOfFDO: request.statusOfFDO,
          FDORequestDate: request.fdoRequestDate,
          FDOResultDate: request.fdoResultDate
        
        })
      );
      const ws = XLSX.utils.json_to_sheet(data);
      /* generate workbook and add the worksheet */
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      const date = new Date().toISOString();

      /* save to file */
      XLSX.writeFile(wb, `Requests - ${date}.xlsx`);
      this.apiParams.page = this.currentPage;
      this.apiParams.pageSize = this.pageSize;
    });
  }

  // routeToRequestDetails(requestId): void {
  //   const selectedReq = this.requestArray.find(
  //     (req) => req.id === requestId.selected[0].id
  //   ) as MedicalRequest;
  //   this.medicalRequestService.setSelectedRequest(selectedReq);
  //   this.router.navigate(['/psp/medication/request-details']);
  // }

  invertSorting() {
    this.invertSort = !this.invertSort;
    this.onSearch(this.searchValue);
  }


  changePageId(pageId){

    this.apiParams.currentPage = 1;
    this.pageSelectionId = pageId;
    this.onSearch(this.searchValue);
  }

  onChangePage(pageDetails: ISmartTablePagination){
    
    this.apiParams.page = pageDetails.offset + 1;
    this.onSearch(this.apiParams);
  }

  getEligiblePrograms(){
    if(IsPermissionExist(PspEvaPermission) && IsPermissionExist(PspLillyPermission)){
      this.eligiblePrograms = this.eligiblePrograms.concat(['All Programs', 'Eva Programs', 'Lilly Programs']);
      this.apiParams.companyId = 0;
    }
  }


    

}
